<template>
  <div id="findPwd">
    <header class="header">
      <img src="../../assets/img/login/logo_page.png" alt class="logo" style="padding-left: 71px;">
    </header>
    <section class="section">
      <div class="title">鹰智BRM系统账号找回密码</div>
      <div id="pwdContent">
        <el-row>
          <el-col :span="3">
            <div :class="step>=1?'active':'num'">1</div>
            <div>
              <div class="f16 titleMain">填写账号</div>
              <div class="f14 c9">
                请填写你要找
                <br>回密码的账号
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div :class="step>=1?'lineActive':'line'"></div>
          </el-col>
          <el-col :span="3">
            <div :class="step>=2?'active':'num'">2</div>
            <div>
              <div class="f16 titleMain">身份认证</div>
              <div class="f14 c9">
                我需要验证一下
                <br>你是不是自己人
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div :class="step>=2?'lineActive':'line'"></div>
          </el-col>
          <el-col :span="3">
            <div :class="step>=3?'active':'num'">3</div>
            <div>
              <div class="f16 titleMain">设置新密码</div>
              <div class="f14 c9">
                现在你可以填写
                <br>你的新密码了
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div :class="step>=3?'lineActive':'line'"></div>
          </el-col>
          <el-col :span="3">
            <div :class="step>=4?'active':'num'">4</div>
            <div>
              <div class="f16 titleMain">设置成功</div>
              <div class="f14 c9">
                新密码已经帮你
                <br>改好
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="step">
          <div>
            <!--填写资料 -->
            <el-form>
              <el-form-item label="" label-width="80px">
                <customHint :msg="form.hintMsg" :ifHint="form.ifHint"></customHint>
              </el-form-item>
            </el-form>
            <el-form ref="form" :model="form" label-width="80px" v-show="step==1&&!form.nobind">
              <el-form-item label="用户名">
                <el-input v-model="form.name" placeholder="请输入用户名或绑定手机号"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 40px;">
                <el-button class="submit" @click="oneStep">提交</el-button>
                <el-button @click="toLogin">返回登录</el-button>
              </el-form-item>
            </el-form>
            <!--身份认证 -->
            <el-form :model="form" v-show="step==2">
              <el-form-item label="手机号：">
                <span>{{form.miMobile}}</span>
              </el-form-item>
              <el-form-item label="验证码：">
                <el-input v-model="form.code" placeholder="请输入验证码" style="width: 199px;"></el-input>
                <el-button style="border:1px solid #c6c6c6;margin-left: 10px;"  v-show="form.codeshow" @click="getCount">获取验证码</el-button>
                <el-button disabled style="border:1px solid #c6c6c6;margin-left: 10px;" v-show="!form.codeshow">{{form.count}} s</el-button>
              </el-form-item>
              <el-form-item v-show="form.readyCode">
                <div  class="step3Btn">
                  <i class="el-icon-success" style="color:#3fb838;margin-right:10px;margin-top:6px;"></i>
                  <div>
                    验证码已发送到你的手机，10分钟内输入有效，
                    <br>验证码等同于密码，打死也不能告诉别人！
                  </div>
                </div>
              </el-form-item>
              <el-form-item style="margin-top: 40px;margin-left: 68px">
                <el-button class="submit" @click="validateSMS">提交</el-button>
                <el-button  @click="step=1">上一步</el-button>
              </el-form-item>
            </el-form>
            <!--未绑定手机号 -->
            <div class="unBindPhone" v-show="form.nobind">
              <img src="../../assets/img/login/error.png" alt class="error">
              <div class="f18">当前账号下未绑定手机号，暂不能找回密码！</div>
              <el-button class="submit" style="margin-top:65px;" @click="step=1,form.nobind=false">返回</el-button>
            </div>
            <!--设置新密码 -->
            <el-form :model="form" v-show="step==3" label-width="90px">
              <el-form-item label="新密码" class="newPwdStrength" >
                <el-input v-model="password" type="password" placeholder="请输入新密码" @blur.prevent="pdwHintShow=false"></el-input>
                <div class="pwdStrength" v-show="pdwHintShow">
                  <div class="f14">强度：{{pwdStatus}}</div>
                  <el-progress :percentage="percentage" :color="form.customColor"></el-progress>
                  <div class="f14 c6">
                    请至少输入 6 个字符。请不要使
                    <br>用容易被猜到的密码。
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="确认新密码">
                <el-input v-model="againPwd" placeholder="输入密码" type="password"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="submit" @click="updatePasswordBySMS">提交</el-button>
                <el-button @click="step=2">上一步</el-button>
              </el-form-item>
            </el-form>
            <!--设置成功 -->
            <div class="unBindPhone" v-show="step==4">
              <img src="../../assets/img/login/set_success.png" alt class="error">
              <div class="f18">新密码设置成功</div>
              <div class="f12 c9">登录时请使用新密码</div>
              <el-button class="submit" style="margin-top:65px;" @click="toLogin">去登录</el-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="footerJS2">Copyright© 2019 杭州久点网络技术有限公司</div>
  </div>
</template>

<script>
  import customHint from "../../components/customHint/customHint";
  import aes from "../../libs/aes";
  export default {
    data: function() {
      return {
        form: {
          name: "",
          show: false,
          code: "",
          password: "",
          againPwd: "",
          customColor: "#f5222d",
          readyCode:false,
          count:60,
          codeshow:true,
          mobile:"",
          miMobile:'',
          nobind:false,
          ifHint:false,
          hintMsg:'',
        },
        step: 1, //步骤
        password:'',
        percentage:0,
        pwdStatus:"弱",
        pdwHintShow:false,
        againPwd:''
      };
    },
    watch:{
      password(val,oldVal){
        val.length!=''?this.pdwHintShow=true:this.pdwHintShow=false
        if(val.length<6){
          this.pwdStatus='弱'
        }
        if(val.length>6&&val.length<10){
          this.pwdStatus='中'
        }
        if(val.length>10){
          this.pwdStatus='强'
        }
        val.length<=10? this.percentage=val.length*10:100
        console.log(this.form.password)
      },
      // againPwd(val,oldVal){
      //   if(this.step==3){
      //     if(val!=this.password){
      //       this.form.hintMsg='两次密码输入不一致'
      //       this.form.ifHint=true
      //     }else{
      //       this.form.ifHint=false
      //     }
      //   }
      //
      // }
    },
    mounted() {
      let a=aes.decrypt('qKUXJTT8tVhxvf0adYqkmg==','hcmabcdefghijklm')
      const path=this.$route.path
      this.form.usertype= localStorage.getItem('usertype');//获取地址栏的最后一位（loginc外部，loginu内部）
      console.log(this.form.usertype)
    },
    methods: {
      toLogin() {
        this.$router.replace(`/login`);
      },
      oneStep() {
        let that=this
        let params={
          name:this.form.name,
          usertype:this.form.usertype
        }
        if(this.form.name==''){
          this.$message({type: 'warning', message: '请输入用户名或绑定手机号'});
          return false
        }
        fetch({
          url: "hcm/login/getUserByNameOrMobile",
          method: "get",
          params:params,
          noFormat: true,
          responseType: "text"
        })
                .then(result => {
                  let res = JSON.parse(result);
                  let {data}=res
                  if(res.status == '10000'){
                    if(data){
                      if(data.mobile==''){
                        //有绑定账号
                        that.form.nobind=true
                      }else{
                        that.form.nobind=false
                        that.form.mobile=data.mobile
                        that.form.miMobile=data.mobile.substr(0, 3) + '****' + data.mobile.substr(7);
                        that.step+=1
                      }
                    }else{
                      this.$message.error('用户名或绑定手机号不存在');
                    }
                  }else{
                    this.$message({type: 'warning', message: ''});
                  }
                })
                .catch(err => {
                  console.log(err)
                })
      },
      getCount(){
        //倒计时
        this.sendCodeSms()
        let that=this
        let form=this.form
        form.count = 60;
        form.codeshow = false;
        form.showError= false;
        form.timer = setInterval(() => {
          if (form.count > 0 && form.count <= 60) {
            form.count--;
          } else {
            form.codeshow = true;
            clearInterval(that.timer);
            that.timer = null;
          }
        }, 1000)
      },
      sendCodeSms(){
        //发送验证码
        let that=this
        let data={
          mobile:this.form.mobile,
          codeType:'HCM_PWD',
          usertype:this.form.usertype
        }
        fetch({
          url: "hcm/login/sendSMS",
          method: "post",
          data:data,
          noFormat: true,
          responseType: "text"
        })
                .then(result => {
                  let res = JSON.parse(result);
                  if(res.status == '10000'){
                    that.form.readyCode=true
                  }else{
                    this.$message({type: 'warning', message: res.message});
                  }
                })
                .catch(err => {
                  console.log(err)
                })
      },
      validateSMS(){
        if (!this.form.code) {
          this.$message({
            message: '请输入验证码',
            type: 'warning'
          });
          return;
        }
        //身份认证提交
        let that=this
        let datas={
          mobile:that.form.mobile,
          code:that.form.code,
          usertype:this.form.usertype
        }
        fetch({
          url: "hcm/login/validateSMS",
          method: "get",
          params:datas,
          noFormat: true,
          responseType: "text"
        })
        .then(result => {
          console.log(result == 'false')
          if(result == 'false'){
            // that.form.hintMsg='验证码有误，请重新输入'
            // that.form.ifHint=true
            this.$message.error('验证码有误，请重新输入');
          }else{
            that.step+=1
            // that.form.ifHint=false
          }
        })
        .catch(err => {
          console.log(err)
        })
      },
      updatePasswordBySMS(){
        if (!this.password) {
          this.$message({
            message: '请输入密码',
            type: 'warning'
          });
          return;
        }
        if (!this.againPwd) {
          this.$message({
            message: '请输入密码',
            type: 'warning'
          });
          return;
        }
        if (this.password.length > 16 || this.password.length < 5) {
          this.$message({
            message: '新密码长度应为 6 - 16 个字符',
            type: 'warning'
          });
          return;
        }
        if (this.againPwd.length > 16 || this.againPwd.length < 5) {
          this.$message({
            message: '新密码长度应为 6 - 16 个字符',
            type: 'warning'
          });
          return;
        }
        if (this.password !== this.againPwd) {
          this.$message.error('两次输入的密码不同，请重新输入');
          return;
        }
        //密码提交
        let that=this
        let datas={
          username :that.form.name,
          password:aes.encrypt(this.password,'hcmabcdefghijklm'),
          usertype:that.form.usertype
        }
        fetch({
          url: "hcm/login/updatePasswordBySMS",
          method: "post",
          data:datas,
          noFormat: true,
          responseType: "text"
        })
                .then(result => {
                  let res = JSON.parse(result);
                  let {data}=res
                  if(res.status == '10000'){
                    that.step+=1
                  }else{
                    that.$message({type: 'warning', message: res.message});
                  }
                })
                .catch(err => {
                  console.log(err)
                })

      }
    },
    components: {
      customHint
    }
  };
</script>
<style scoped>
  @import "../../style/login.scss";
</style>
<style scoped lang="scss">
  #findPwd {
    width: 100%;
    background: url("../../assets/img/login/forget_bg.png") no-repeat;
    background-size: 100% 100%;
    .header {
      width: 100%;
      height: 86px;
      background: #fff;
      display: flex;
      align-items: center;
    }
    #pwdContent {
      background: #fff;
      width: 1240px;
      height: 720px;
      margin: auto;
      padding: 86px 60px 0 60px;
      box-sizing: border-box;
      .el-col {
        display: flex;
        justify-content: flex-start;
      }
      .num {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #e6e6e6;
        text-align: center;
        line-height: 30px;
        font-size: 16px;
        color: #fff;
        margin-right: 12px;
      }
      .active {
        background: #cfa972;
      }
      .titleMain {
        margin-bottom: 16px;
      }
      .line {
        border-bottom: 1px solid #dcdfe6;
        width: 88%;
        height: 15px;
      }
      .lineActive {
        border-bottom: 1px solid #cfa972;
      }
    }
    .title {
      text-align: center;
      font-size: 24px;
      margin: 30px 0;
    }
    .submit {
      background: #cfa972;
      color: #fff;
    }
    .el-button:active {
      border-color: #cfa972;
    }
    .step {
      margin-top: 155px;
      .el-form,
      .unBindPhone {
        width: 400px;
        margin: auto;
        .error {
          width: 49px;
          height: 48px;
          margin: 0 auto 25px;
        }
      }
      .unBindPhone {
        text-align: center;
      }
      .step3Btn {
        margin-left: 68px;
        display: flex!important;
        justify-content: flex-start;
        font-size: 14px;
        color: #666666;
        line-height: 26px;
      }
      .newPwdStrength {
        position: relative;
        .pwdStrength {
          line-height: 20px;
          width: 240px;
          height: 95px;
          background: url("../../assets/img/login/pwdStrength_bg.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: -79%;
          top: -17px;
          box-sizing: border-box;
          padding: 13px 13px 13px 24px;
        }
      }

    }
  }
</style>
<style>
  .el-progress__text {
    display: none;
  }
</style>
